((ProductImg, $) => {
  'use strict';

  const allImages = [];

  let $body;
  let $section;
  let $altImageContainer;
  let $mainImages;
  let $videoButton;
  let $video;
  let $videoButtonMobile;
  let $videoMobile;
  let $videoMobileClose;
  let $videoAltImage;
  let $slider;

  const cacheDom = () => {
    $body = $('body');
    $section = $('.product-alt-section');
    $altImageContainer = $section.find('.product-alt-item-image').not('.js-product-alt-item-video');
    $mainImages = $('.main-product-image');
    $videoButton = $('.js-product-video-button');
    $video = $('.js-product-video');
    $videoButtonMobile = $('.js-product-video-button--mobile');
    $videoMobile = $('.js-product-video-mobile');
    $videoMobileClose = $('.js-product-video-mobile-close');
    $videoAltImage = $section.find('.js-product-alt-item-video');
    $slider = $('.slider');
  };

  const change = ($this, direction) => {
    const $imgTag = $this.parent().find('img');
    const currentIndex = parseInt($this.parent().find('img').attr('data-current-index'), 10);
    const indexes = setImageIndexes(currentIndex, direction);

    changeImage($imgTag, indexes);
  };

  const show = () => {
    $('#product-modal').fadeIn(300).css('display', 'flex');
    window.Scroll.lock();
  };

  const itemIndexInArray = (arr, item) => {
    return arr.indexOf(item);
  };

  const playVideo = ($this, $currentVideo) => {
    $this.hide();
    $currentVideo.fadeIn()[0].play();
  };

  const stopVideo = ($button, $currentVideo) => {
    $button.fadeIn();
    $currentVideo.fadeOut()[0].pause()
  };

  const bindUIActions = () => {
    $altImageContainer.on('click', function swapMainImage() {
      const index = $(this).attr('data-index');

      $mainImages.hide(0).css('opacity', 1);

      $mainImages.each(function showCorrectImage() {
        if ($(this).attr('data-index') === index) {
          $(this).fadeIn();
        }
      });


      $video.fadeOut()[0].pause();
      $videoButton.fadeIn();
    });

    $videoButton.on('click', function () {
      playVideo($(this), $video);
      $mainImages.css('opacity', 0);
    });

    $videoButtonMobile.on('click', function () {
      playVideo($(this).parents('.product-video-image-container--mobile'), $videoMobile);
      $slider.css('opacity', 0);
    });

    $videoMobile.on('pause', function () {
      $(this).fadeOut()[0].pause();
      $videoButtonMobile.parents('.product-video-image-container--mobile').fadeIn();
      $slider.css('opacity', 1);
    });

    $videoAltImage.on('click', function () {
      playVideo($videoButton, $video);
      $mainImages.css('opacity', 0);
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  ProductImg.init = init;
})(window.ProductImg = window.ProductImg || {}, jQuery);
